import Vue from 'vue'
import VueRouter from 'vue-router'
import { Message } from 'element-ui'

Vue.use(VueRouter)

const routes = [
    {
        path: '/',
        redirect: '/dashboard',
    },
    {
        path: '/login',
        name: 'Login',
        component: () => import('../components/Login.vue'),
        meta: {
            title: '登录',
            requiresAuth: false,
        },
    },
    {
        path: '/dashboard',
        name: 'Dashboard',
        component: () => import('../components/Dashboard.vue'),
        meta: {
            title: '仪表盘',
            requiresAuth: true,
        },
    },
    {
        path: '/note-creation',
        name: 'NoteCreation',
        component: () => import('../components/NoteCreation.vue'),
        meta: {
            title: '图文笔记制作',
            requiresAuth: true,
        },
    },
    {
        path: '/task-manage',
        name: 'TaskManage',
        component: () => import('../components/TaskManage.vue'),
        meta: {
            title: '任务管理',
            requiresAuth: true,
        },
    },
    {
        path: '/task-join',
        name: 'TaskJoin',
        component: () => import('../components/TaskJoin.vue'),
        meta: {
            title: '任务参与',
            requiresAuth: true,
        },
    },
    {
        path: '/item-manage',
        name: 'ProductManage',
        component: () => import('../components/ProductManage.vue'),
        meta: {
            title: '商品管理',
            requiresAuth: true,
        },
    },
    {
        path: '/note-manage',
        name: 'NoteManage',
        component: () => import('../components/NoteManage.vue'),
        meta: {
            title: '笔记管理',
            requiresAuth: true,
        },
    },
    {
        path: '/note-video-manage',
        name: 'NoteVideoManage',
        component: () => import('../components/NoteVideoManage.vue'),
        meta: {
            title: '笔记管理',
            requiresAuth: true,
        },
    },  {
        path: '/short-video-manage',
        name: 'ShortVideoManage',
        component: () => import('../components/ShortVideoManage.vue'),
        meta: {
            title: '笔记管理',
            requiresAuth: true,
        },
    }, {
        path: '/note-text-manage',
        name: 'NoteTextManage',
        component: () => import('../components/NoteTextManage.vue'),
        meta: {
            title: '笔记管理',
            requiresAuth: true,
        },
    }, {
        path: '/fire-copy-manage',
        name: 'FileCopyManage',
        component: () => import('../components/FireCopyManage.vue'),
        meta: {
            title: '爆文结构复用',
            requiresAuth: true,
        },
    },
    {
        path: '/item-pic',
        name: 'PicManage',
        component: () => import('../components/PicManage.vue'),
        meta: {
            title: '商品图片管理',
            requiresAuth: true,
        },
    },
    {
        path: '/item-text',
        name: 'TextManage',
        component: () => import('../components/TextManage.vue'),
        meta: {
            title: '商品文本编辑',
            requiresAuth: true,
        },
    },
    {
        path: '/order-manage',
        name: 'OrderManage',
        component: () => import('../components/OrderManage.vue'),
        meta: {
            title: '交易记录',
            requiresAuth: true,
        },
    },
    {
        path: '/note-edit',
        name: 'NoteEdit',
        component: () => import('../components/NoteEdit.vue'),
        meta: {
            title: '笔记编辑',
            requiresAuth: true,
        },
    }, {
        path: '/note-export',
        name: 'NoteEdit',
        component: () => import('../components/NoteExport.vue'),
        meta: {
            title: '笔记导出',
            requiresAuth: true,
        },
    },
    {
        path: '/404',
        name: 'NotFound',
        component: () => import('../components/NotFound.vue'),
        meta: {
            title: '页面未找到',
            requiresAuth: false,
        },
    },  {
        path: '/koutu',
        name: 'KoutuManage',
        component: () => import('../components/KoutuManage.vue'),
        meta: {
            title: '抠图',
            requiresAuth: false,
        },
    },
    {
        path: '*',
        redirect: '/404',
    },
]

const router = new VueRouter({
    mode: 'hash',
    base: process.env.BASE_URL,
    routes,
})

/**
 */
const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location, onResolve, onReject) {
    if (onResolve || onReject) {
        return originalPush.call(this, location, onResolve, onReject)
    }
    return originalPush.call(this, location).catch(err => err)
}

const originalReplace = VueRouter.prototype.replace
VueRouter.prototype.replace = function replace(location, onResolve, onReject) {
    if (onResolve || onReject) {
        return originalReplace.call(this, location, onResolve, onReject)
    }
    return originalReplace.call(this, location).catch(err => err)
}

/**
 * 检查用户是否已登录
 */
function isAuthenticated() {
    const token = localStorage.getItem('token')
    const userInfo = localStorage.getItem('user_info')
    return !!(token && userInfo)   // 返回 true/false
}

/**
 * 清理认证信息
 */
function clearAuthData() {
    localStorage.removeItem('token')
    localStorage.removeItem('user_info')
    localStorage.removeItem('remembered_username')
}

/**
 * 全局前置守卫
 */
router.beforeEach((to, from, next) => {
    const isAuth = isAuthenticated()

    if (to.path === '/login') {
        if (isAuth) {
            Message.info('您已经登录，正在跳转到仪表盘...')
            next({ path: '/dashboard', replace: true })
        } else {
            next()
        }
        return
    }

    const requiresAuth = to.matched.some(record => record.meta.requiresAuth !== false)

    if (requiresAuth && !isAuth) {
        clearAuthData()
        if (to.path !== '/login' && to.path !== '/') {
            localStorage.setItem('redirect_after_login', to.fullPath)
        }
        Message.warning('请先登录')
        next({ path: '/login', replace: true })
        return
    }

    next()
})

/**
 * 全局后置钩子
 */
router.afterEach((to, from) => {
    console.log(`页面从 ${from.path} 跳转到 ${to.path}`)
    if (to.meta && to.meta.title) {
        document.title = to.meta.title
    }
})

/**
 * 路由错误处理
 */
router.onError((error) => {
    console.error('路由错误:', error)
    Message.error('页面加载失败，请刷新重试')
})

export default router
